<template>
	<div class="full">
		<vxe-grid v-bind="gridOptions" v-if="gridOptions" :loading="loading" ref="wlnpurchaseLog"></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			currentRow: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				loading: false,
				gridOptions: null,
				toolbarButton:[],
				detail:[]
			}
		},
		watch: {
			currentRow(e) {
				if (e) {
					this.$api.log.list({
						dataid:e.id,
						formname:'c_wlnpurchase',
					}).then((res) => {
						//console.log(res)
						this.$refs.wlnpurchaseLog.reloadData(res)
					})
				} else {
					this.tableData = []
				}
			}
		},
		computed: {

		},
		created() {

		},
		mounted() {
			this.gridOptions = this.getOption()	
		},
		methods: {
			getOption() {
				return {
					id: 'wlnpurchaseLog',
					border: true,
					size: 'mini',
					columns: this.getColumns(),
					columnConfig: {
						isHover: false,
						resizable: true
					},
					customConfig: {
						storage: true
					},
					cellStyle:this.cellStyle,
					toolbarConfig: {
						size: 'mini',
						perfect: false,
						buttons: [],
						customConfig: {
							storage: true
						},
					},
					rowConfig: {
						isHover: true,
						isCurrent: true,
					},
					showOverflow: true,
					height: 'auto',
					pagerConfig: {
						enable: false
					},
					proxyConfig: {},
					sortConfig: {
						remote: false
					}
				}
			},
			getColumns() {
				return [{
					field: 'staffid',
					title: '操作人',
					formatter:({row})=>{
						return window.systemMethods.getstaff(row.staffid)
					}
				}, {
					field: 'action',
					title: '操作',
					formatter:({row})=>{
						let map = {
							send:'报货：发送',
							copy:'报货：复制',
							takegoods:'提货',
							cancel:'取消提货',
						}
						return map[row.action]
					}
				}, {
					field: 'detail',
					title: '关联商品',
					formatter:({row})=>{
						return row.param.goodscode
					}
				}, {
					field: 'create_time',
					title: '操作时间',
					formatter:({row})=>{
						return window.systemMethods.timestampToDate(row.create_time,false)
					}
				}]
			}
		},
		components: {
			
		}
	}
</script>